import { render, staticRenderFns } from "./CompanyLoans.vue?vue&type=template&id=df33d08c&scoped=true&"
import script from "./CompanyLoans.vue?vue&type=script&lang=js&"
export * from "./CompanyLoans.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLoans.vue?vue&type=style&index=0&id=df33d08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df33d08c",
  null
  
)

export default component.exports